import type { ProjectEvent } from "@/engine/types";

export const act1Events: ProjectEvent[] = [
  {
    id: "exec_deadline_request",
    title: "The Executive Request",
    sender: "Director",
    day: "Day 1",
    eligibleWhen: (state) => state.day === 1,
    body: [
      "\"Leadership wants the first hospital's encounter dashboard migrated to the new AWS environment. We'd like production ready in 4 weeks. Can you confirm?\"",
      "Data Engineer: \"Pipeline itself? Probably 8–10 working days.\"",
      "BI Developer: \"Dashboard changes should only take about 4 days.\"",
      "10 + 4 = 14 days. Four weeks looks comfortable. But you don't yet know how long security review, source-system access, data validation, UAT, deployment, or defect correction will take.",
    ],
    choices: [
      {
        id: "accept",
        text: "Accept the four-week deadline",
        description: "Engineering only needs ~14 days, leaving plenty of buffer.",
        effects: [
          { metric: "schedule", delta: -20 },
          { metric: "teamTrust", delta: -10 },
        ],
        resultText:
          "Director is pleased — you sounded confident. But you committed to a date with 8 unscoped workstreams hiding inside your 'buffer,' and the team wasn't consulted on the commitment.",
        schedules: [{ eventId: "eng_estimate_revision", eligibleOnDay: 3 }],
      },
      {
        id: "reject",
        text: "Reject the deadline, request eight weeks",
        description: "Tell the director four weeks is unrealistic.",
        effects: [{ metric: "stakeholderTrust", delta: -15 }],
        resultText:
          "Director pushes back: \"Eight weeks with no analysis to back that number? Leadership will ask what you actually did to earn it.\" Guessing in the other direction is just as unfounded as the first.",
        schedules: [{ eventId: "exec_escalation", eligibleOnDay: 2 }],
      },
      {
        id: "investigate_dependencies",
        text: "Don't commit yet — decompose the work first",
        description:
          "Tell the director you'll return with an estimate after decomposing the work with engineering, BI, security, data governance, and the business owner.",
        effects: [
          { metric: "schedule", delta: -5 },
          { metric: "teamTrust", delta: 5 },
        ],
        resultText:
          "Director: \"Fine, but I need something by end of week.\" You've bought room to do this right — and put a clock on it.",
        schedules: [{ eventId: "vendor_dependency_found", eligibleOnDay: 2 }],
      },
      {
        id: "accept_conditionally",
        text: "Accept four weeks conditionally, start immediately",
        description: "Begin engineering now, sort out dependencies as you go.",
        effects: [
          { metric: "schedule", delta: -10 },
          { metric: "stakeholderTrust", delta: 5 },
          { metric: "quality", delta: -5 },
        ],
        resultText:
          "Engineering starts building against a data source that hasn't cleared access review. You're racing dependencies you can't see the shape of yet.",
        schedules: [{ eventId: "scope_negotiation", eligibleOnDay: 3 }],
      },
    ],
  },
];
